import axiosInstance from '../config/axios.js';

const API_BASE = '/qr-scan-notices';

const qrScanNoticeService = {
  list: async (checked, extra = {}) => {
    const params = { ...extra };
    if (checked === true) params.checked = '1';
    if (checked === false) params.checked = '0';
    Object.keys(params).forEach((key) => {
      if (params[key] === '' || params[key] == null) delete params[key];
    });
    const response = await axiosInstance.get(API_BASE, { params });
    return response.data;
  },

  unreadCount: async () => {
    const response = await axiosInstance.get(`${API_BASE}/unread-count`);
    return response.data;
  },

  check: async (recipientId) => {
    const response = await axiosInstance.post(`${API_BASE}/${recipientId}/check`);
    return response.data;
  },

  checkAll: async () => {
    const response = await axiosInstance.post(`${API_BASE}/check-all`);
    return response.data;
  },
};

export default qrScanNoticeService;
